import { createSlice } from '@reduxjs/toolkit';
import { UsersListStateType } from 'src/types/usersList';

const initialState: UsersListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const usersListSlice = createSlice({
    name: 'usersList',
    initialState,
    reducers: {
        getUsersListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getUsersListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getUsersListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        activateUserFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        activateUserFetchSuccess: (state, action) => {
            state.loading = false;
        },
        activateUserFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        deactivateUserFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deactivateUserFetchSuccess: (state, action) => {
            state.loading = false;
        },
        deactivateUserFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getUsersListFetch,
    getUsersListFetchSuccess,
    getUsersListFetchFailure,
    activateUserFetch,
    activateUserFetchSuccess,
    activateUserFetchFailure,
    deactivateUserFetch,
    deactivateUserFetchSuccess,
    deactivateUserFetchFailure,
} = usersListSlice.actions;

export default usersListSlice.reducer;
